import React from 'react';
import PropTypes from 'prop-types';
import './FieldRadio.sass';

import cx from 'classnames';

export default function FieldRadio({input, meta: {touched, error} = {}, title, children, label, className, ...rest}) {
  const displayError = (touched && error);

  return (
    <div className={cx('field-radio', className)}>
      {title && <div className="field-radio__title">{title}</div>}

      <div className="field-radio__input-wrap">
        <label className="field-radio__name">
          <input {...rest} {...input} type="radio" className="field-radio__input"/>
          <span className="field-radio__name-text">
            <span className="field-radio__check" />
            {children}
          </span>
        </label>

        {displayError && (<div className="field-radio__error-message">{error}</div>)}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldRadio/FieldRadio.js